import { newrelic } from './newrelic';

/* eslint-disable @typescript-eslint/no-var-requires */
const Metrics = require('@customink/metrics').default;
const metrics = new Metrics();
const isAnalyticsEnabled = ['production', 'staging'].includes(
  import.meta.env.MODE,
);

export const pageViewTag = (pageViewTag: string, options?: object) => {
  if (isAnalyticsEnabled) {
    metrics.pageViewTag(pageViewTag, options);
    newrelic.addPageAction(pageViewTag, options);
  } else {
    if (options) {
      console.log(`Page View Tag ${pageViewTag}: ${JSON.stringify(options)}`);
    } else {
      console.log(`Page View Tag ${pageViewTag}`);
    }
  }
};

export const fireEvent = (
  category: string,
  action?: string,
  label?: string,
) => {
  if (isAnalyticsEnabled) {
    metrics.fireEvent(category, action, label);
    newrelic.addPageAction(category, { action, label });
  } else {
    console.log(`Event Fired: "${category}" "${action}" "${label}"`);
  }
};
